/*global moment */
import { getTemplate } from "../template-helper.js";
import { runInContext } from "../binding.js";


const COMPONENT_NAME = "z-calendar" ;

const TEMPLATE_ID = "component-"+COMPONENT_NAME+"-template" ;
const TEMPLATE_URL = "/static/libs/components/"+COMPONENT_NAME+".html" ;

export default function register(){
    return getTemplate(TEMPLATE_ID, TEMPLATE_URL).then((template)=>{
        
        class CalendarComponent extends HTMLElement {
            constructor() {
                super();
            }

            connectedCallback(){
                this.init() ;
            }


            init(){
                this.div = this.querySelector(".z-calendar-container") ;
                if(!this.div){
                    const clone = document.importNode(template.content, true);
                    this.appendChild(clone);
                    this.div = this.querySelector(".z-calendar-container") ;
                }


                const rootNode = this.getRootNode();
                if(!rootNode || !rootNode.getElementById){ 
                    return  ;
                }

                this.doImport().then(()=>{
                    if(!this.ownerDocument || !this.ownerDocument.defaultView){
                        return ;
                    }
                    const FullCalendar = this.ownerDocument.defaultView.FullCalendar ;

                    let weekends = true ;
                    if(this.hasAttribute("z-hide-weekends")){
                        weekends = false ;
                    }
                    let headerToolbar = "today" ;
                    if(this.hasAttribute("z-available-modes")){
                        headerToolbar += " "+this.getAttribute("z-available-modes") ;
                    }
                    headerToolbar += " prev,next";

                    let options = {
                        themeSystem:'bootstrap',
                        initialView: this.viewType,
                        initialDate: this.date,
                        locale: navigator.language.substring(0,2),
                        weekends: weekends,
                        headerToolbar: {
                            start: 'title', 
                            center: '',
                            end: headerToolbar
                        },
                        eventDisplay: "block",
                        events: (info, callback) => {
                            callback(this.getEvents(info.start, info.end)) ;
                        },
                        dateClick: (info) => {
                            this.dispatchEvent(new CustomEvent("click", { bubbles: true, detail: info}));
                        },
                        select: (info) => {
                            this.dispatchEvent(new CustomEvent("select", { bubbles: true, detail: info}));
                        },
                        datesSet: (info) => {
                            this.dispatchEvent(new CustomEvent("change", { bubbles: true, detail: info}));
                        },
                        eventResize: (info) => {
                            const elEvent = info.event.extendedProps.el ;
                            if(elEvent && elEvent.getData){
                                info.data = elEvent.getData() ;
                            }
                            this.dispatchEvent(new CustomEvent("resize", { bubbles: true, detail: info}));
                        },
                        eventDrop: (info) => {
                            const elEvent = info.event.extendedProps.el ;
                            if(elEvent && elEvent.getData){
                                info.data = elEvent.getData() ;
                            }
                            this.dispatchEvent(new CustomEvent("moved", { bubbles: true, detail: info}));
                        },
                        eventMouseEnter: (info)=> {
                            const elEvent = info.event.extendedProps.el ;
                            if(elEvent){
                                const elPopup = elEvent.querySelector("z-calendar-popup") ;
                                if(elPopup && elPopup.openMode === "hover"){
                                    elPopup.style.display = "block";
                                    window.jQuery(info.el).tooltip({
                                        title: elPopup,  
                                        html: true,
                                        container: this
                                    }); 
                                    window.jQuery(info.el).tooltip("show") ;
                                    window.jQuery(info.el).on('hidden.bs.tooltip',  () =>{
                                        elPopup.style.display = "";
                                        elEvent.appendChild(elPopup) ;
                                        window.jQuery(info.el).tooltip("dispose") ;
                                    }) ;
                                }
                            }
                        },
                        eventMouseLeave: function(info) {
                            // if(this.currentHover && this.currentHover.parentElement){
                            //     this.currentHover.parentElement.removeChild(this.currentHover) ;
                            // }
                        },
                        eventClick: function(info) {
                            const elEvent = info.event.extendedProps.el ;
                            if(elEvent){
                                if(elEvent.getData){
                                    info.data = elEvent.getData() ;
                                }
                                elEvent.dispatchEvent(new CustomEvent("eventclick", { bubbles: true, detail: info}));
                                const elPopup = elEvent.querySelector("z-calendar-popup") ;
                                if(elPopup && elPopup.openMode === "click"){
                                    window.dialogs.openDialog((elModal, $modal)=>{
                                        let styles = elEvent.getRootNode().querySelectorAll("style") ;
                                        for(let style of styles){
                                            if(style.id !== "style_z_icon_picker_inline"){
                                                let styleCopy = document.createElement("style") ;
                                                styleCopy.innerHTML = style.innerHTML ;
                                                elModal.appendChild(styleCopy) ;
                                            }
                                        }
                                        elModal.appendChild(elPopup) ;
                                        $modal.on('hide.bs.modal', function () {
                                            elEvent.appendChild(elPopup) ;
                                        });
                                        $modal.on('hidden.bs.modal', function () {
                                            $modal.modal('dispose') ;
                                            const modalRoot = elModal.closest(".modal") ;
                                            modalRoot.parentElement.removeChild(modalRoot) ;
                                        });
                                    }, {size : elPopup.size || "medium"}) ;
                                }
                            }
                        }
                    } ;

                    let attrs = this.attributes ;
                    for(let attr of attrs){
                        if(/^z-cal-option-/.test(attr.name)){
                            let optName = attr.name.substring(13).split("-").map((v, i)=>{
                                if(i>0){
                                    return v.substring(0,1).toUpperCase()+v.substring(1) ;
                                }else{
                                    return v ;
                                }
                            }).join("") ;
                            let value = attr.value ;
                            if(value === "true"){ 
                                value = true ; 
                            }else if(value === "false"){ 
                                value = false ; 
                            }else if(value === "undefined"){ 
                                value = undefined ; 
                            }else if(value && 
                                (
                                    (value[0] === "{" && value[value.length -1]=== "}") ||
                                    (value[0] === "[" && value[value.length -1]=== "]") 
                                )){
                                    try{
                                        value = JSON.parse(value) ;
                                    }catch(e){
                                        console.error("WRONG VALUE "+value, e) ;
                                    }
                            }
                            if(value && value.indexOf && value.indexOf("func:") === 0){
                                try{
                                    value = runInContext(this, {}, value.replace("func:", "")) ;
                                }catch(err){
                                    console.error("Error while running ", value, err);
                                }
                            }
                            const optPath = optName.split(".") ;
                            let optObject = options;
                            while(optPath.length>1){
                                const p = optPath.shift() ;
                                if(!optObject[p]){
                                    optObject[p] = {} ;
                                }
                                optObject = optObject[p] ;
                            }
                            optObject[optPath.shift()] = value ;
                        }
                    }

                    this.calendar = new FullCalendar.Calendar(this.div, options);

                    this.calendar.render();

                    new IntersectionObserver((entries, observer) => {
                        entries.forEach(entry => {
                          if(entry.intersectionRatio > 0) {
                            this.calendar.render();
                            observer.disconnect();
                          }
                        });
                    }).observe(this);

                    this.renderEvents() ;
                }) ;
            }

            renderCalendar(){
                if(!this.calendar){ return ; }
                this.calendar.changeView(this.viewType, this.date);
            }
            
            updateHeaderToolbar(){
                if(!this.calendar){ return ; }
                let headerToolbar = "today" ;
                if(this.hasAttribute("z-available-modes")){
                    headerToolbar += " "+this.getAttribute("z-available-modes");
                }
                headerToolbar += " prev,next";
                this.calendar.setOption("headerToolbar", {
                    start: 'title', 
                    center: '',
                    end: headerToolbar
                }) ;
            }

            updateWeekends(){
                if(!this.calendar){ return ; }
                let weekends = true ;
                if(this.hasAttribute("z-hide-weekends")){
                    weekends = false ;
                }
                this.calendar.setOption("weekends", weekends) ;
            }

            getEvents(startCalendar, endCalendar){
                const events = Array.prototype.slice.apply(this.querySelectorAll("z-calendar-event")) ;
                const calEvents = [] ;
                for(let elEvent of events){
                    const start = elEvent.getAttribute("z-start");
                    const end = elEvent.getAttribute("z-end") ;
                    if((start && startCalendar <= new Date(start) && endCalendar >= new Date(start)) ||
                        (end && startCalendar <= new Date(end) && endCalendar >= new Date(end))){

                            const event = {
                                allDay: elEvent.hasAttribute("z-all-day"), 
                                start: start, 
                                end: end, 
                                title: elEvent.getAttribute("z-title")||"", 
                                color: elEvent.getAttribute("z-color"), 
                                textColor: elEvent.getAttribute("z-text-color"), 
                                extendedProps: {
                                    el: elEvent
                                }
                            } ;

                            let attrs = elEvent.attributes ;
                            for(let attr of attrs){
                                if(/^z-event-option-/.test(attr.name)){
                                    let optName = attr.name.substring(15).split("-").map((v, i)=>{
                                        if(i>0){
                                            return v.substring(0,1).toUpperCase()+v.substring(1) ;
                                        }else{
                                            return v ;
                                        }
                                    }).join("") ;
                                    let value = attr.value.trim() ;
                                    if(value === "true"){ 
                                        value = true ; 
                                    }else if(value === "false"){ 
                                        value = false ; 
                                    }else if(value && 
                                        (
                                            (value[0] === "{" && value[value.length -1]=== "}") ||
                                            (value[0] === "[" && value[value.length -1]=== "]") 
                                        )){
                                            try{
                                                value = JSON.parse(value) ;
                                            }catch(e){
                                                console.error("WRONG VALUE "+value, e) ;
                                            }
                                    }
                                    if(value && value.indexOf && value.indexOf("func:") === 0){
                                        try{
                                            value = runInContext(elEvent, {}, value.replace("func:", "")) ;
                                        }catch(err){
                                            console.error("Error while running ", value, err);
                                        }
                                    }
                                    const optPath = optName.split(".") ;
                                    let optObject = event;
                                    while(optPath.length>1){
                                        const p = optPath.shift() ;
                                        if(!optObject[p]){
                                            optObject[p] = {} ;
                                        }
                                        optObject = optObject[p] ;
                                    }
                                    optObject[optPath.shift()] = value ;
                                }
                            }
                            
                            const eventUrl = elEvent.getAttribute("z-url") ;
                            if(eventUrl && eventUrl !== "null" && eventUrl !== "undefined"){
                                event.url = eventUrl ;
                            }
                            calEvents.push(event) ;
                    }
                }
                return calEvents ;
            }

            renderEvents(){
                if(!this.calendar){ return ; }
                if(this.renderTimeout ){
                    clearTimeout(this.renderTimeout) ;
                }
                this.renderTimeout = setTimeout(()=>{
                    this.calendar.refetchEvents() ;
                }, 200) ;
            }
            
            doImport() {
                let rootNode = this.getRootNode();
                if(rootNode === this) { return Promise.resolve(); }
                if(!rootNode || !rootNode.getElementById){ return Promise.resolve(); }

                let head = rootNode;
                if(rootNode.head){
                    head = rootNode.head ;
                }

                const styleTag = rootNode.getElementById("style_z_calendar") ;
                if(styleTag){ return rootNode.importCalendarPromise; }

                let s = document.createElement("link");
                s.rel = "stylesheet";
                s.type = "text/css";
                s.id = "style_z_calendar" ;
                s.href = (window.isCordova?'':'/')+"node_modules/fullcalendar/main.css";
                
                head.appendChild(s);

                var sInline = document.createElement('style');
                sInline.id = "style_z_icon_picker_inline" ;
                sInline.setAttribute('type', 'text/css');
                sInline.appendChild(document.createTextNode(`
                    z-calendar { display: block; min-width: 200px; min-heigth: 200px; width: 200px; height: 200px }
                    div[class^="col-"] z-calendar { width: 100% }
                    .z-calendar-container { width: 100%; height: 100% }
                    z-calendar-popup { display: none; }
                `));
                head.appendChild(sInline);
                
                rootNode.importCalendarPromise = new Promise((resolve, reject)=>{
                    let script = document.createElement("script");
                    script.async = true;
                    script.type = "text/javascript";
                    script.src = (window.isCordova?'':'/')+"node_modules/fullcalendar/main.js";
                    script.onload = function(_, isAbort) {
                        if (!script.readyState || "complete" === script.readyState) {
                            if (isAbort){
                                reject("can't load fullcalendar") ;
                            }else{
                                let script = document.createElement("script");
                                script.async = true;
                                script.type = "text/javascript";
                                script.src = (window.isCordova?'':'/')+"node_modules/fullcalendar/locales-all.min.js";
                                script.onload = function(_, isAbort) {
                                    if (!script.readyState || "complete" === script.readyState) {
                                        if (isAbort){
                                            reject("can't load fullcalendar") ;
                                        }else{
                                            resolve() ;
                                        }
                                    }
                                };
                                
                                script.onreadystatechange = script.onload ;
                                
                                script.onerror = function () {
                                    reject("can't load fullcalendar") ;
                                };
                                
                                head.appendChild(script);
                            }
                        }
                    };
                    
                    script.onreadystatechange = script.onload ;
                    
                    script.onerror = function () {
                        reject("can't load fullcalendar") ;
                    };
                    
                    head.appendChild(script);
                }) ;
                return rootNode.importCalendarPromise;
            }

            get viewType(){
                return this.getAttribute("z-view-type")||"dayGridMonth";
            }
            set viewType(viewType){
                this.setAttribute("z-view-type", viewType);
            }
            get date(){
                return this.getAttribute("z-date")||new Date().toISOString();
            }
            set date(date){
                this.setAttribute("z-date", date);
            }

            static get observedAttributes() {
                return ["z-view-type", "z-date", "z-available-modes", "z-hide-weekends"];
            }

            get value(){
                if(this.calendar){
                    return {
                        start: this.calendar.getCurrentData().viewApi.activeStart,
                        end: this.calendar.getCurrentData().viewApi.activeEnd,
                    } ;
                }else{
                    let startDate = this.date ;
                    let endDate = startDate ;
                    if(this.viewType === "dayGridMonth"){
                        endDate = moment(startDate).endOf("month").endOf("week").toDate().toISOString() ; 
                        startDate = moment(startDate).startOf("month").startOf("week").toDate().toISOString() ; 
                    }else if(this.viewType === "timeGridWeek" || this.viewType === "listWeek"){
                        startDate = moment(startDate).startOf("week").toDate().toISOString() ; 
                        endDate = moment(startDate).endOf("week").toDate().toISOString() ; 
                    }
                    return {
                        start: startDate,
                        end: endDate
                    } ;
                }
            }

            set value(value){
                if(value && value.start){
                    this.date = value.start ;
                }
            }

            attributeChangedCallback(name, oldValue, newValue) {
                switch (name) {
                    case 'z-view-type':
                    case 'z-date':
                        this.renderCalendar();
                        break;
                    case 'z-available-modes':
                        this.updateHeaderToolbar();
                        break;
                    case 'z-hide-weekends':
                        this.updateWeekends();
                        break;
                   
                }
            }
           
        }
        customElements.define(COMPONENT_NAME, CalendarComponent);

        class CalendarEventComponent extends HTMLElement {
            constructor() {
                super() ;
            }

            connectedCallback() {
                this.renderEvent() ;
            }

            disconnectedCallback(){
                if(this.event){
                    this.event.remove() ;
                }
            }

            renderEvent(){
                const zCalendar = this.closest("z-calendar") ;
                if(zCalendar){
                    zCalendar.renderEvents() ;
                }
            }

            static get observedAttributes() {
                return ["z-all-day", "z-start", "z-end", "z-title", "z-color", "z-text-color"];
            }

            attributeChangedCallback(name, oldValue, newValue) {
                this.renderEvent();
            }
        }
        customElements.define("z-calendar-event", CalendarEventComponent);
        
        class CalendarPopupComponent extends HTMLElement {
            constructor() {
                super() ;
            }

            get openMode(){
                return this.getAttribute("z-open-mode")||"hover";
            }
            set openMode(openMode){
                this.setAttribute("z-open-mode", openMode);
            }
            get size(){
                return this.getAttribute("z-size")||"medium";
            }
            set size(size){
                this.setAttribute("z-size", size);
            }
        }
        customElements.define("z-calendar-popup", CalendarPopupComponent);

    }).catch((err)=>{
        throw err ;
    }) ;
}
